module.exports = __webpack_public_path__ + "media/assets/images/check-checkbox-f7694fc14a219c1ea1bbc277a6c2155a.png";